import React from 'react'

const HowWork = () => {
    return (
        <>

            <div className="container-fluid features overflow-hidden bg-light py-5" style={{marginTop:"-80px"}}>
                <div className="container">
                    <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h5 className="sub-title text-primary px-3">Shiv Travels Taxi Services</h5>
                        </div>
                        <h1 className="display-5 mb-4">Why choose us?</h1>
                      
                    </div>
                    <div className="row g-4 justify-content-center text-center">
                        <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-car fa-4x text-primary" />
                                    {/* <i className="fa-solid fa-car" /> */}

                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Wide Range of Cars</h5>
                                    <p className="mb-3">From little sedans to large SUVs and luxury vehicles, we have a variety of automobiles to meet your needs.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-credit-card fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Affordable Prices</h5>
                                    <p className="mb-3">Get excellent service without breaking the bank. For high-quality rides, we have the greatest costs.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-cab fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Professional Drivers</h5>
                                    <p className="mb-3">Our drivers are courteous, competent, and concerned about your comfort and safety.</p>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-address-book-o fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Clean & Comfortable Cars</h5>
                                    <p className="mb-3">We maintain our vehicles to ensure a consistently enjoyable journey.</p>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fas fa-users fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Customer First</h5>
                                    <p className="mb-3">Our first goal is your satisfaction. We work hard to provide outstanding service for all of your travel requirements.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="feature-item text-center p-4">
                                <div className="feature-icon p-3 mb-4">
                                    <i className="fa fa-bar-chart-o fa-4x text-primary" />
                                </div>
                                <div className="feature-content d-flex flex-column">
                                    <h5 className="mb-3">Always On Time</h5>
                                    <p className="mb-3">Your time is valuable to us. Our drivers make sure you arrive at your location on time by being on time.</p>
                                    
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>



        </>
    )
}

export default HowWork